export default __webpack_public_path__ + "static/char-s-47-zh-Hans-09e8a89474db71ed5bc40f1aaafc5ba5.png";